// V2 port of v1's LinkedOrdersDisplay — a chip showing the customer order
// + line this WO belongs to. v2 has one WO per (customer order line), so
// this is always a single chip (visual slot preserved for 1-to-1 parity).

import React from 'react';
import { Box, Typography, Chip, Tooltip } from '@mui/material';
import { Assignment } from '@mui/icons-material';

export default function LinkedOrdersDisplayV2({ step }) {
  if (!step?.customer_order_number) return null;
  const ordered = parseFloat(step.line_quantity_ordered || 0);
  const shipped = parseFloat(step.line_quantity_shipped || 0);
  const remaining = Math.max(0, ordered - shipped);
  const isOverdue = step.due_date && new Date(step.due_date) < new Date();
  const label = `${step.customer_order_number}/L${step.line_number}${
    remaining > 0 ? ` (×${Math.round(remaining)})` : ''
  }`;

  return (
    <Box sx={{ mt: 0.5 }} onClick={(e) => e.stopPropagation()}>
      <Typography
        variant="caption"
        color="text.secondary"
        sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}
      >
        <Assignment sx={{ fontSize: '0.9rem' }} />
        Orders:
      </Typography>
      <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 0.5, mt: 0.25, alignItems: 'center' }}>
        <Tooltip
          arrow
          title={
            <Box>
              <Typography variant="caption" display="block" fontWeight="bold">
                {step.customer_name || step.customer_order_number}
              </Typography>
              {ordered > 0 && (
                <Typography variant="caption" display="block">
                  Qty ordered: {Math.round(ordered)} | Remaining: {Math.round(remaining)}
                </Typography>
              )}
              {step.due_date && (
                <Typography variant="caption" display="block">
                  Due: {new Date(step.due_date).toLocaleDateString()}
                </Typography>
              )}
            </Box>
          }
        >
          <Chip
            data-testid={`linked-order-chip-${step.customer_order_line_id}`}
            label={label}
            size="small"
            variant="outlined"
            color={isOverdue ? 'error' : 'primary'}
            sx={{
              height: 20,
              fontSize: '0.7rem',
              '& .MuiChip-label': { px: 1 },
            }}
          />
        </Tooltip>
      </Box>
    </Box>
  );
}
